var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditNoteAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#E4E7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4227 10.0248L18.8862 12.4993M9.11377 22H20.8862M16.3836 8.58022C17.1687 7.54275 18.2575 8.09833 19.0813 8.68762C19.9051 9.27692 20.7747 10.1222 19.9896 11.1596L14.2135 18.4927C13.9749 18.808 13.6167 19.0175 13.2184 19.0748L11.2158 19.3631C10.9424 19.4024 10.6876 19.2201 10.6449 18.9546L10.3319 17.01C10.2697 16.6234 10.3689 16.2285 10.6075 15.9133L16.3836 8.58022Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNoteAction);
export default __webpack_public_path__ + "static/media/edit-note-action.2add4b3b8969c5c1d0d84ed0cf3a40fc.svg";
export { ForwardRef as ReactComponent };